import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata,Fetchupdatequery,Fetchfileupload,FetchsavePoRows } from '../../../services/process/BRS1/brsService7';
import { CreateData} from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import excelIcon from '../../../assets/images/excel.png'; // Ensure these icons exist
import pdfIcon from '../../../assets/images/pdf.png';
import logo from '../../../assets/images/1.png'; // Adjust the path to your image
import jsPDF from 'jspdf';
import 'jspdf-autotable';


function PoCreation() {
  const [formData, setFormData] = useState({});
  const [formData2, setFormData2] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [rowData1, setRowData1] = useState([]);
  const [rowData2, setRowData2] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [fields2, setFields2] = useState(null);
  const [fields3, setFields3] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false );
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const gridRef1 = useRef(null);



  const fetchData = async () => {
    await fetchFieldInfo(54, setFields2, setColumnDefs2);
    await fetchFieldInfo(35, setFields1, setColumnDefs);
    await fetchFieldInfo(60, setFields2, setColumnDefs3);
    await fetchFieldInfo(84, setFields, setColumnDefs);
    await fetchFieldInfo(53, setFields2, setColumnDefs1);
    await fetchFieldInfo(36, setFields3, setColumnDefs); 
   setLoading(false); // Stop loading after fetching all field info
  };

  const fetchData2 = async () => {
    fetchFieldInfo2();
    setLoading(false); // Stop loading after fetching all field info
  };


  useEffect(() => {
  fetchData();
  }, []);

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

const handleTabChange1 = (index) => {
  setActiveTab(index);
  console.log("User switched to tab:", index);
  
  // Perform specific logic based on tab
  if (index === 1) {
    // View Purchase Orders tab
    fetchData2();
  } else if (index === 2) {
    // Purchase Order File Upload tab
    fetchFieldInfo3();
  }
};


 const fetchFieldInfo = async (headerConfigId, setFieldsFunc, setColumnDefsFunc) => {
  const payload = { headerconfig_id: headerConfigId,filterconditions: filterconditions};
  
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], 
        payload, 
        FileUploadCredentials[0]
      );
  
      const data = response.data;
      console.log("fetched data",data)

      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true,
          resizable: true

        }));
	if (headerConfigId === 54){
        columns.push({
          headerName: "View",
          field: "edit",
          cellRendererFramework: (params) => (
    <Icon
      name="eye"
      style={{ cursor: 'pointer' }}
      onClick={() => handleEditClick(params.data)}
    />
          ),
          width: 100, // Set width for the edit column
        });} else if (headerConfigId === 60){
        columns.unshift({
        headerCheckboxSelection: true, // Add this line for the checkbox selection
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true, // Add this line for the checkbox selection
        width: 20
      },
     );}
if (headerConfigId !== 60 && headerConfigId !== 54) {
  columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
    <Icon
      name="eye"
      style={{ cursor: 'pointer' }}
      onClick={() => handleEditClick1(params.data)}
    />
          ),
          width: 100, // Set width for the edit column
        });
}


        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        console.log("updation completed")
        return { fields: data.fields };
      }
    } catch (error) {
      console.error(`Error fetching field info for headerConfigId ${headerConfigId}:`, error);
      setError("Error fetching fields data");
        return { fields: []};
    }
  };
    
  const handleEditClick1 = async(row) => {
    await fetchFieldInfo(83, setFields, setColumnDefs);
  const cleanedRow = Object.fromEntries(
    Object.entries(row).filter(([key]) => key !== "Sl.No")
  );
    console.log(cleanedRow)
    setFormData(cleanedRow); // Populate formData with row data for editing
    setEditMode(true); // Set edit mode to true
  setActiveTab(0);
  };


  const handleEditClick = async(row) => {
    console.log(row)
    const payload = { query: `SELECT * from payments.stg_purchase_order where stg_setting_value = ${row.file_uploads_id}` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData2(data);
        setShowPopup(true);

        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };


  const fetchFieldInfo2 = async () => {
    const payload = { query: `SELECT (@row_num := @row_num + 1) as 'Sl.No', IFNULL(TRIM(month), '') AS 'month', IFNULL(TRIM(purchase_order_number), '') AS 'purchase_order_number', IFNULL(DATE_FORMAT(po_date, '%Y-%m-%d'), '') AS 'po_date', IFNULL(DATE_FORMAT(po_expiry_date, '%Y-%m-%d'), '') AS 'po_expiry_date', IFNULL(TRIM(vendor_code), '') AS 'vendor_code', IFNULL(TRIM(vendor_name), '') AS 'vendor_name', IFNULL(TRIM(po_purpose), '') AS 'po_purpose', IFNULL(TRIM(delivery_location), '') AS 'delivery_location', IFNULL(TRIM(po_kind), '') AS 'po_kind', IFNULL(TRIM(expense_category), '') AS 'expense_category', IFNULL(TRIM(department_category), '') AS 'department_category', IFNULL(TRIM(sbu_head), '') AS 'sbu_head', IFNULL(TRIM(cost_code), '') AS 'cost_code', IFNULL(CONVERT(provision_cost, CHAR), '0.00') AS 'provision_cost', IFNULL(CONVERT(provision_amount, CHAR), '0.00') AS 'provision_amount', IFNULL(CONVERT(gst_amount, CHAR), '0.00') AS 'gst_amount', IFNULL(CONVERT(total_po_value, CHAR), '0.00') AS 'total_po_value', IFNULL(TRIM(po_requestor), '') AS 'po_requestor', IFNULL(TRIM(po_type), '') AS 'po_type', IFNULL(TRIM(prepared_by), '') AS 'prepared_by', IFNULL(TRIM(cross_checked_by), '') AS 'cross_checked_by', IFNULL(TRIM(po_status_approved_by), '') AS 'po_status_approved_by', IFNULL(TRIM(payment_terms), '') AS 'payment_terms', IFNULL(TRIM(delivery_period), '') AS 'delivery_period', IFNULL(TRIM(ap_module_ibn), '') AS 'ap_module_ibn', IFNULL(TRIM(budgeted_or_not_budgeted), '0') AS 'budgeted_or_not_budgeted', IFNULL(TRIM(purchase_order_type), '') AS 'purchase_order_type', id FROM payments.purchase_order, (SELECT @row_num := 0) as r WHERE is_purchase_order = 1 AND entity_id = ${userCredentials.selectedentity} AND is_active = 1 ORDER BY id DESC;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);
        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const fetchFieldInfo3 = async () => {
    const payload = { query: `SELECT file_uploads_id,IFNULL(TRIM(file_name), '') AS 'file_name', IFNULL(CONVERT(file_size, CHAR), '0') AS 'file_size_bytes', IFNULL(TRIM(status), '') AS 'status', IFNULL(TRIM(comments), '') AS 'comments', DATE_FORMAT(uploaded_time, '%d-%m-%Y %H:%i:%s') AS 'created_on' FROM process_data.file_uploads WHERE source_id = 207 and is_active = 1 AND entities_id = ${userCredentials.selectedentity} ORDER BY file_uploads_id DESC LIMIT 30;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData1(data);
        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };




const gridRef = useRef();

const onBtnExportCSV = () => {
  gridRef.current.api.exportDataAsCsv();
};

const exportToPDF = () => {
  const filteredColumns = columnDefs1.filter((col) => col.field !== "id");
  const tableColumn = filteredColumns.map((col) => col.headerName);

  const gridApi = gridRef.current.api;
  const displayedRows = [];
  gridApi.forEachNodeAfterFilter((node) => displayedRows.push(node.data));

  const tableRows = displayedRows.map((row) =>
    filteredColumns.map((col) =>
      row[col.field] !== undefined && row[col.field] !== null
        ? String(row[col.field])
        : ""
    )
  );

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a3",
  });

  // Title + Logo
  doc.addImage(logo, "PNG", 10, 5, 28, 14);
  doc.setFontSize(14);
  doc.text("Purchase Order Report", 150, 15);

  // Generate metadata
  const now = new Date();
  const generatedAt = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
  const generatedBy = userCredentials.user_name || "System";

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 25,
    theme: "grid",
    styles: {
      fontSize: 4,
      cellPadding: 1,
      overflow: "linebreak",
    },
    headStyles: {
      fillColor: [10, 35, 82],
      textColor: 255,
      fontSize: 5,
    },
    margin: { top: 25, left: 5, right: 5 },

    didDrawPage: (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      const footerY = doc.internal.pageSize.height - 8;

      doc.setFontSize(6);

      // Page Number � left side
      doc.text(
        `Page ${data.pageNumber} of ${pageCount}`,
        data.settings.margin.left,
        footerY
      );

      // Generated by � center
      const genByText = `Generated by: ${generatedBy}`;
      const genByWidth = doc.getTextWidth(genByText);
      doc.text(
        genByText,
        (doc.internal.pageSize.width - genByWidth) / 2,
        footerY
      );

      // Generated date & time � right
      const genAtWidth = doc.getTextWidth(generatedAt);
      doc.text(
        generatedAt,
        doc.internal.pageSize.width - genAtWidth - 5,
        footerY
      );
    },
  });

  doc.save("PurchaseOrder.pdf");
};

  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

const formatDateTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const pad = (n, size = 2) => String(n).padStart(size, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
         `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.000000`;
};

const handleCreate = async () => {
  const formattedDate = getFormattedDate();
  console.log("PO formData", formData);

  // Build list_values consistently
  const listValue = [
    formData.purchase_order_number,
    formatDateTime(formData.po_date),
    formatDateTime(formData.po_expiry_date),userCredentials.selectedentity
  ].join("|");  // ? match DB format with spaces

  // Step 1: Check if record already exists
  const checkPayload = { 
    query: `SELECT * 
            FROM payments.purchase_order 
            WHERE list_values = '${listValue}';` 
  };

  try {
    const checkCredentials = Fetchexecutequery();
    const checkResponse = await axios.post(
      checkCredentials[1],
      checkPayload,
      checkCredentials[0]
    );

    const data = checkResponse.data;

    // Step 2: Only create if record not found
    if (data.length === 0) {
      const updatedFormData = {
        ...formData,
        created_on: formattedDate,
        last_updated_on: formattedDate,
        entity_id: userCredentials.selectedentity,
        created_by: userCredentials.user_id,
        modified_by: userCredentials.user_id,
        last_updated_by: userCredentials.user_name,
        is_purchase_order: 1,
        is_milestone_added: 0,
        list_values: listValue
      };

      const createPayloadData = createPayload(
        'payments',
        'purchase_order',
        updatedFormData
      );

      const createCredentials = CreateData();

      const createResponse = await axios.post(
        createCredentials[1],
        createPayloadData,
        createCredentials[0]
      );

      console.log("Create response:", createResponse);
      window.location.reload();
    } else {
      alert("Duplicate entry: PO already exists with same PO number");
    }
  } catch (error) {
    console.error("Error in handleCreate:", error);
    setError("Error creating data");
  }
};

  const handleUpdate = () => {

    const formattedDate = getFormattedDate();
    const updatedFormData = { ...formData,
        last_updated_on: formattedDate,
        modified_by: userCredentials.user_id,
        last_updated_by: userCredentials.user_name
 };

    // Remove primary_id from the copied formData
    delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'payments',
      table: 'purchase_order',
      set_column : updatedFormData,
      'where' : [{"id":formData.id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleInputChange = (name, value) => {
  setFormData(prevData => {
    // Always update the current field
    const updated = {
      ...prevData,
      [name]: value
    };

    // If any numeric fields involved, convert safely
    const provision = Number(updated.provision_cost) || 0;
    const gst = Number(updated.gst_amount) || 0;

    // Recalculate only when provision or gst changed
    if (name === "provision_cost" || name === "gst_amount") {
      updated.total_po_value = provision + gst;
    }

    return updated;
  });

  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

const handleFileuploadSave = () => {
  const selectedRows = gridRef1.current.api.getSelectedRows();
  console.log("Selected Rows:", selectedRows);

  const selectedIds = selectedRows.map(row => row.id);

  if (selectedIds.length === 0) {
    alert("Please select at least one row.");
    return;
  }

    const payload = {
      'ids': selectedIds,
      'last_updated_by': userCredentials.user_name,  
    };

    const FileUploadCredentials = FetchsavePoRows();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
	alert("Records Saved Successfully!!!");
	setShowPopup(false);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
	alert("Error in Saving Records!!!");
        setError("Error updating data");
      });

};



const handlefileupload = () => {
  const formattedDate = getFormattedDate();

  const updatedFormData = {
    ...formData2,
    last_updated_on: formattedDate,
    modified_by: userCredentials.user_id,
    last_updated_by: userCredentials.user_name
  };
  console.log("updatedFormData",updatedFormData)

  const filePath = "/data/p2p/Production/Projects/TeamLease/PaymentsProcess/data/PurchaseOrder/input/";  // Update this with the actual value

  const payload = {
    ...updatedFormData,
    file_path: filePath,
    source_name: "purchase_order",
    config_id: 13,
    month: "2024-12", // or from formData.month
    skiprows: 0,
    table: "stg_purchase_order",
    tenants_id: userCredentials.tenants_id,
    groups_id: userCredentials.groups_id,
    entities_id: userCredentials.selectedentity,
    user_id: userCredentials.user_id,
    source_type: "YourSourceType",
    process_id:36
  };

  const FileUploadCredentials = Fetchfileupload();

  axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
    .then(response => {
      console.log("Upload response:", response);
      setEditMode(false);
      fetchFieldInfo3();
      window.location.reload();
    })
    .catch((error) => {
      console.error("Error uploading file:", error);
      setError("Error uploading file");
    });
};


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

 if (loading) return <LoaderComponent loaderOpen={true}/>;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        Purchase Order Details
      </h2>


            <Tabs selectedIndex={activeTab} onSelect={(index) => handleTabChange1(index)}>
        <TabList>
          <Tab>Create Purchase Order</Tab>
          <Tab>View Purchase Orders</Tab>
          <Tab>Purchase Order Fileupload</Tab>
        </TabList>

      {error && <div style={{ color: "red" }}>{error}</div>}

       <TabPanel>
          <div style={{ margin: "10px" }}>
<h3 onClick={toggleDiv1} style={{ cursor: "pointer", color: "#4969ab", paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
  PO Details
  <span style={{ fontSize: '24px', fontWeight: 'bold', marginLeft: '10px' }}>
    {isDiv1Open ? '-' : '+'}
  </span>
</h3>
        {isDiv1Open && (
            <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />)}


            <div className="submit-row">
              <button type="submit" className="submit-btn" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </TabPanel>

        <TabPanel>

<div
  style={{
    display: "flex",
    alignItems: "center",   // ?? fixes extra top space
    padding: "10px",
  }}
>
  <img
    src={excelIcon}
    alt="Export to Excel"
    title="Download Excel"
    onClick={onBtnExportCSV}
    style={{
      width: "28px",
      height: "28px",
      cursor: "pointer",
      marginRight: "8px",
    }}
  />

  <Icon
    name="file pdf outline"
    title="Download PDF"
    onClick={exportToPDF}
    style={{
      fontSize: "28px",
      color: "#d9534f",
      cursor: "pointer",
      marginRight: "12px",
    }}
  />

  <div style={{ marginLeft: "auto" }}>
    <input
      className="search-input"
      type="text"
      placeholder="Search..."
      value={globalFilter}
      onChange={(e) => {
        setGlobalFilter(e.target.value);
        gridRef.current.api.setQuickFilter(e.target.value);
      }}
      style={{
        width: "280px",
        backgroundColor: "white",
        padding: "7px 12px",
        height: "34px",
        lineHeight: "34px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        boxSizing: "border-box",
      }}
    />
  </div>
</div>

          <div className="ag-theme-alpine" style={{height:'480px',width: '1600px',borderRadius:'8px' }}>
            <AgGridReact
              rowData={rowData}
              ref={gridRef}
              columnDefs={columnDefs1}
              pagination={true} // Enable pagination
              paginationPageSize={10} // Set the number of rows per page
              filter={true} // Enable filtering on the grid level

            />
          </div>
        </TabPanel>
        <TabPanel>
           <DynamicForm fields={fields3} formData={formData2} onInputChange={(name, value) => {
              setFormData2((prev) => ({ ...prev, [name]: value }));
            }} />
            <div className="submit-row">
              <button type="submit" className="submit-btn" onClick={handlefileupload}>
                Upload
              </button>
            </div>
          <div className="ag-theme-alpine" style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${5 * 250}px`,
              height : '400px'
         }}>
            <AgGridReact
              rowData={rowData1}
              columnDefs={columnDefs2}
              pagination={true} // Enable pagination
              paginationPageSize={8} // Set the number of rows per page
              filter={true} // Enable filtering on the grid level
            />
          </div>

        </TabPanel>

      </Tabs>
{showPopup && (
  <>
    {/* Overlay */}
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 999
      }}
    />

    {/* Popup */}
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
        zIndex: 1000,
        padding: '16px',
        minWidth: '400px'
      }}
    >

      {/* AG Grid */}
      <div
        className="ag-theme-alpine"
        style={{
          overflowX: 'auto',
          overflowY: 'auto',
          borderRadius: '10px',
          width: `${5 * 250}px`,
          height: '420px'
        }}
      >
<AgGridReact
  ref={gridRef1}
  rowData={rowData2}
  columnDefs={columnDefs3}
  pagination={true}
  paginationPageSize={8}
  filter={true}
  rowSelection="multiple" // or "single"
  suppressRowClickSelection={true}
  enableRangeSelection={true}
  suppressCopyRowsToClipboard={false}
/>

      </div>
<div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '16px' }}>
  <button type="submit" className="submit-btn" onClick={handleFileuploadSave}>
    Save
  </button>
  <button type="submit" className="submit-btn" onClick={() => setShowPopup(false)}>
    Close
  </button>
</div>

    </div>
  </>
)}

    </div>
  );
}

export default PoCreation;
